import { maskHelper } from '../helpers/mask.helper'
import { connect } from 'react-redux'
import store from '../helpers/store'

class TripDiscountHelper {
	static getFamilyDiscount(discountParameters) {
		let busSeatsCondition = 9999
		if (discountParameters && discountParameters.isActive) {
			busSeatsCondition = discountParameters.busSeatsCondition
		}

		return busSeatsCondition
	}

	static checkAllowedBusCompanies(
		familyDiscountParameters,
		selectedBusSeatsGoing
	) {
		const allowedCompanies =
			familyDiscountParameters.allowedBusCompanys.split(',')

		let busCompany = ''

		if (selectedBusSeatsGoing && Array.isArray(selectedBusSeatsGoing)) {
			let firstBusSelected = null

			firstBusSelected = selectedBusSeatsGoing[0]
			busCompany = firstBusSelected ? firstBusSelected.busCompany : ''
		} else {
			busCompany = selectedBusSeatsGoing
		}

		return allowedCompanies.includes(busCompany)
	}

	static checkInvalidRoutes(origin, destination) {
		if (!origin || !destination) {
			return false
		}
		let blockedTrips = store.getState().site.invalidDiscountRoutes

		let tripFounded = blockedTrips.find((trip) => {
			const { normalize } = maskHelper

			const tripOrigin = normalize(trip.originCity)
			const tripDestination = normalize(trip.destinationCity)
			const currentOrigin = normalize(origin)
			const currentDestination = normalize(destination)

			if (
				(tripOrigin == currentOrigin &&
					tripDestination == currentDestination) ||
				(tripOrigin == currentDestination &&
					tripDestination == currentOrigin)
			) {
				return trip
			}
		})

		return !!tripFounded
	}
}

export default TripDiscountHelper
